module.exports = __webpack_public_path__ + "img/tubiao-06.99eda862.png";